/* eslint-disable no-lone-blocks */
import { Box, Grid } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'
import Container from '../../components/layout_micro/container'
import { SectionHeader } from './main'
import SectionDivider from './sectionDivider'
import auto from '../../../assets/auto.png'

const Ul = styled.ul`
  li {
    font-size: 1.3em;
    color: var(--first);
  }
`
const Picture = styled.img`
  width: 400px;
  display: block;
  margin: 1em auto;
  @media screen and (max-width:1400px) {
    margin: 1.5em auto;
    width: 300px;
  }
  @media screen and (max-width:1000px) {
    width: 200px;
    margin: 2em auto;
  }
`

const SubText = styled.div`
  font-size: 1.5em;
  font-weight: bold;
  color: var(--first);
  margin-bottom: 1em;
  margin-top: 1em;
`

const WrapperS = styled.div`
  margin: 5em 0em;
  padding: 1px;
`

const Line = styled.div`
  border-bottom: 2px solid var(--second);
  margin-top: 3em;
  margin-bottom: 1em;
`

const Header = styled.div`
  background-color: var(--second);
  font-size: 3em;
  line-height: 1em;
  border-radius: 0em 1em 0em 1em;
  padding: 1em 3em;
  color: #fff;
  font-weight:  bold;
  @media screen and (max-width:1400px) {
    font-size: 2.5em;
  }
  @media screen and (max-width:1000px) {
    margin: 2em auto;
    padding: 1em 2em;
  }
  @media screen and (max-width:600px) {
    margin: 2em auto;
    padding: 1em 1em;
    font-size: 2em;
  }
`

const Indications = props => {
  return (
    <WrapperS>
      <Container id='indications'>
        <Header>
          Indicaciones para el día
          de la toma de muestra
        </Header>
        <Line />
      </Container>
      <Container>
        <SectionDivider step={1}>
          <SectionHeader title='Agendar la cita y presentar el correo de confirmación (Mostrarlo en el celular).' />
        </SectionDivider>
        <Line />
      </Container>
      <Container>
        <SectionDivider step={2}>
          <SectionHeader title='Presentarse bajo las siguientes condiciones.' />
          <Box>
            <Ul>
              <li>No lavar boca ni hacer gargarismos antes de la toma de muestra.</li>
              <li>No haber consumidos alimentos 3 horas antes de la toma de muestra (preferente).</li>
              <li>No aplicar tratamientos tópicos (spray nasal) en las fosas nasales el día de la toma de muestra.</li>
              <li>No tomar antivirales 48 horas antes de la toma de muestra.</li>
              <li>No tomar antihistamínicos (preferente).</li>
              <li>Utilizar cubrebocas.</li>
            </Ul>
          </Box>
        </SectionDivider>
        <Line />
      </Container>
      <Container>
        <SectionDivider step={3}>
          <SectionHeader title={<>Al llegar a nuestras instalaciones, estacionarse a un costado de la entrada principal. <br />Ubica nuestro módulo externo.'</>} />
          <Box>
            <Picture src={auto} />
          </Box>
          <SubText>La toma de la muestra solo aplica en la Sucursal UNIDAD ARCOS Dirección: Ramón Rodríguez Familiar #36, Jardines de Querétaro, Querétaro, Qro. 76020. </SubText>
          <Grid container justify='center'>
            <Grid xs={12} md={10} lg={8}>
              <iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3734.8274951290523!2d-100.3792401850746!3d20.595101186234885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d35b341055d781%3A0x146f46a53b9508d1!2siml%20Laboratorio%20M%C3%A9dico!5e0!3m2!1ses!2smx!4v1604594967182!5m2!1ses!2smx' width='100%' height='450' frameBorder='0' allowFullScreen='' aria-hidden='false' tabIndex='0' />
            </Grid>
          </Grid>
        </SectionDivider>
        <Line />
      </Container>
      <Container>
        <SectionDivider step={4}>
          <SectionHeader title={<>Nuestro personal le indicará donde estacionarse.<br /> En todo momento debe permanecer en su vehículo.</>} />
        </SectionDivider>
        <Line />
      </Container>
      <Container>
        <SectionDivider step={5}>
          <SectionHeader title='Nuestro personal verificará sus datos.' />
          <Box>
            <Ul>
              <li>Información personal</li>
              <li>Pago en caso de que aplique</li>
              <li>Firma de consentimiento informado</li>
              <li>Condiciones de toma.</li>
            </Ul>
          </Box>
        </SectionDivider>
        <Line />
      </Container>
      <Container>
        <SectionDivider step={6}>
          <SectionHeader title='Nuestro personal le explicará el procedimiento y realizará la toma de muestra.' />
          <Box>
            <SubText>Desde la comodidad de su automóvil, agilizamos el tiempo para la toma de muestra. Lo que le permite no afectar sus actividades del día. La toma de muestra es de garganta (exudado faríngeo) y de nariz (exudado nasofaríngeo).</SubText>
            <Ul>
              <li>Estacionar y apagar el vehículo. </li>
              <li>Permanecer en el vehículo y bajar completamente la ventana.</li>
              <li>Girar su cuerpo hacia la ventana.</li>
              <li>Evitar lo más posible estornudar o toser durante el procedimiento.</li>
              <li>Exudado faríngeo. Inclinar la cabeza y cerrar sus ojos. Abrir su boca y sacar su
                lengua. Nuestro personal con ayuda del abatelenguas y un hisopo realizará un
                raspado de la faringe.
              </li>
              <li>Exudado nasofaríngeo. Mantener su cabeza recta y mirando hacia el frente.
                Nuestro personal introducirá un hisopo en una de las fosas nasales (narina)
                de forma cuidadosa.
              </li>
            </Ul>
          </Box>
        </SectionDivider>
        <Line />
      </Container>
      <Container>
        <SectionDivider step={7}>
          <SectionHeader title='Una vez finalizado el procedimiento podrá retirarse de nuestras instalaciones.' />
        </SectionDivider>
        <Line />
      </Container>
      <Container>
        <SectionDivider step={8}>
          <SectionHeader title='La entrega de resultados y factura (en caso de haberla solicitado) será enviada vía correo electrónico.' />
        </SectionDivider>
      </Container>
    </WrapperS>
  )
}

export default Indications
